/**
 * Signed-out landing. Clerk's <SignIn> is mounted inline rather than as a
 * redirect so the app stays a single static page — no server routes to add on
 * Render, and the SPA rewrite keeps working.
 */
import { SignIn } from "@clerk/clerk-react";
import { Terminal } from "lucide-react";

export function SignInScreen() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center p-6 gap-8"
      style={{
        /* The signed-out screen needs the insets too — clipping before the
           user has even authenticated is the worst first impression. */
        paddingTop: "calc(1.5rem + env(safe-area-inset-top, 0px))",
        paddingBottom: "calc(1.5rem + env(safe-area-inset-bottom, 0px))",
        paddingLeft: "calc(1.5rem + env(safe-area-inset-left, 0px))",
        paddingRight: "calc(1.5rem + env(safe-area-inset-right, 0px))",
      }}
    >
      <div className="text-center space-y-4">
        <div className="flex justify-center">
          <div className="relative">
            <div className="w-20 h-20 brand-tile rounded-2xl flex items-center justify-center glow-effect">
              <Terminal className="w-10 h-10" />
            </div>
            <div className="absolute -top-2 -right-2 w-5 h-5 bg-primary rounded-full animate-pulse-ring" />
          </div>
        </div>

        <div>
          <h1 className="text-4xl font-bold code-font tracking-tight mb-2">
            DASHBASE
          </h1>
          <p className="text-muted-foreground max-w-sm">
            Bookmarks, dailies, focus sessions, quests and your plan for the day
            — in one place.
          </p>
        </div>
      </div>

      <SignIn
        routing="hash"
        appearance={{
          elements: {
            rootBox: "w-full flex justify-center",
            card: "bg-card border border-border shadow-xl",
          },
        }}
      />
    </div>
  );
}
